import { useCallback, useState, type ReactNode } from "react";

import {
  ConfigOutlineContext,
  EMPTY_OUTLINE,
  type ConfigOutlineState,
} from "./configOutlineContext";

export function ConfigOutlineProvider({ children }: { children: ReactNode }) {
  const [outline, setOutlineState] =
    useState<ConfigOutlineState>(EMPTY_OUTLINE);
  const setOutline = useCallback(
    (next: ConfigOutlineState) => setOutlineState(next),
    [],
  );
  return (
    <ConfigOutlineContext.Provider value={{ outline, setOutline }}>
      {children}
    </ConfigOutlineContext.Provider>
  );
}
